import { styled } from '@mui/system';
import { TableRow } from '@mui/material';
import AddressbookLabel from '#component/addressbook/dashboard/addressbook-label';

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'hover'
})(({ theme, hover }) => ({
  textDecoration: 'none',
  ...(hover && {
    '&:hover td:not([rowspan])': {
      backgroundColor: theme.palette.action.hover
    }
  })
}));

export const StyledAddressbookLabel = styled(AddressbookLabel)(({ theme }) => ({
  marginTop: theme.spacing(-1.25),
  marginBottom: theme.spacing(-1.25)
}));
